/** @jsxImportSource @emotion/react */

import React from "react";
import { css, jsx } from "@emotion/react";
import { Box, Flex } from "reflexbox";
import lodash from "lodash";
import { Controls } from "./Controls";
import copy from "copy-to-clipboard";
import useDimensions from "react-use-dimensions";
import {
	CustomizerContext,
	CustomizerContextProvider,
} from "./CustomizerContext";
import { Preview } from "./Preview";

function CustomizerWrapped(props) {
	return (
		<CustomizerContextProvider {...props}>
			<Customizer {...props} />
		</CustomizerContextProvider>
	);
}

function Customizer() {
	let {
		customizerAttributes,
		AttributesState,
		CodeState,
		PreviewCodeState,
		InitialLoadState,
	} = React.useContext(CustomizerContext);
	let [previewCode, setpreviewCode] = PreviewCodeState;

	const [ref, { width: widgetWidth }] = useDimensions();

	let isSmall = widgetWidth < 650;

	let [code, setCode] = CodeState;

	let { subscribed } = customizerAttributes;

	return (
		<Box
			ref={ref}
			className={`pcoplus-customizer-widget ${isSmall ? `isSmall` : `isLarge`}`}
		>
			<Flex alignItems="center" flexWrap={isSmall ? "wrap-reverse" : "inherit"}>
				<Box flex={isSmall ? "100%" : 1} mx={3} my={3}>
					<Box
						m={1}
						css={css`
							background-color: #33333311;
							border-radius: 2pt;
							border: 1pt solid #ddd;
							font-size: 8.5pt;
						`}
					>
						{subscribed && (
							<Box textAlign="right" mx={2} mt={1}>
								<button
									onClick={() => {
										copy(code);
									}}
									type="button"
									className="btn btn-sm  btn-outline-primary"
									css={css`
										font-size: 0.9em;
									`}
								>
									<i className="fas fa-copy"></i>&nbsp;Copy
								</button>
							</Box>
						)}

						<pre
							css={css`
								${!subscribed && `filter:blur(4px); user-select:none;  `}
							`}
							className="pre-scrollable"
						>
							<code className="text-secondary">
								{subscribed ? code : code.substr(0, 260)}
							</code>
						</pre>
						{!subscribed && (
							<>
								<Box
									mx={4}
									pb={5}
									textAlign="center"
									css={css`
										font-size: 2.6em;
										line-height: 1.1em;
									`}
								>
									This embed code is only available to subscribers.
								</Box>
							</>
						)}
					</Box>
				</Box>
				<Box flex="1" my={3}>
					<Controls />
				</Box>
			</Flex>

			<Box mt={4}>
				<h3>Preview</h3>

				<Preview previewCode={previewCode} />
			</Box>
		</Box>
	);
}

export default CustomizerWrapped;
